import { AvatarSizes, renderAvatar } from '../avatars/renderAvatar';

type UserAvatarProps = {
  firstName?: string;
  lastName?: string;
  src?: string;
  size?: number;
  userUuid?: string;
  noTooltip?: boolean;
};

const sizeToEnum = (size: number) => {
  if (size <= 24) return AvatarSizes.SMALL;
  if (size >= 40) return AvatarSizes.LARGE;
  return AvatarSizes.DEFAULT;
};

export const UserAvatar = ({
  firstName = '',
  lastName = '',
  src,
  size = 32,
  userUuid,
  noTooltip,
}: UserAvatarProps) =>
  renderAvatar(
    firstName,
    lastName,
    sizeToEnum(size),
    userUuid,
    src,
    undefined,
    noTooltip,
  );
